import { Component, ViewChild, ElementRef, OnInit } from '@angular/core';
import { CoreProvider } from 'src/app/services/core';
import { Platform } from '@ionic/angular';
import { VersionServiceProvider } from 'src/app/services/version-service';

@Component({
  selector: 'page-updatemodal',
  styleUrls: ['updatemodal.scss'],
  templateUrl: 'updatemodal.html',
})
export class UpdatemodalPage implements OnInit {

  @ViewChild('days', { static: false }) days: ElementRef;
  @ViewChild('hours', { static: false }) hours: ElementRef;
  @ViewChild('minutes', { static: false }) minutes: ElementRef;
  @ViewChild('seconds', { static: false }) seconds: ElementRef;

  private static oppenedData: boolean = false;
  public static get oppened(): boolean {
    return UpdatemodalPage.oppenedData;
  }

  countDownTimer = {days:0, hours:0, minutes:0, seconds:0};
  countDownTimerStr: number|string = 'cargando...';
  countDownInterval;

  constructor(private core: CoreProvider, private platform: Platform) {}

  getCowntdownTimer() {
    let distance = this.core.getDateFromTimestamp(this.ver.expireTimestamp).getTime() - new Date().getTime();

    this.countDownTimer.days = Math.floor(distance / (1000 * 60 * 60 * 24));
    this.countDownTimer.hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    this.countDownTimer.minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    this.countDownTimer.seconds = Math.floor((distance % (1000 * 60)) / 1000);

    this.countDownTimerStr = `${this.countDownTimer.days} días, ${this.countDownTimer.hours} horas, ${this.countDownTimer.minutes} minutos y ${this.countDownTimer.seconds} segundos`;
    this.updateTimerCss();
  }

  updateTimerCss() {
    if (this.days) this.days.nativeElement.style.setProperty('--var-number', this.countDownTimer.days + 'px');
    if (this.hours) this.hours.nativeElement.style.setProperty('--var-number', this.countDownTimer.hours + 'px');
    if (this.minutes) this.minutes.nativeElement.style.setProperty('--var-number', this.countDownTimer.minutes + 'px');
    if (this.seconds) this.seconds.nativeElement.style.setProperty('--var-number', this.countDownTimer.seconds + 'px');
  }

  update() {
    if (this.platform.is('android')) {
      alert('Para actualizar diríjase a google play');
    } else {
      this.ver.update();
    }
  }

  ngOnInit() {
    UpdatemodalPage.oppenedData = true;
    this.countDownInterval = setInterval(() => this.getCowntdownTimer(), 1000);
  }

  ionViewDidLeave() {
    clearInterval(this.countDownInterval);
    UpdatemodalPage.oppenedData = false;
  }

  ver: VersionServiceProvider = this.core.version;
  dismiss = () => this.core.modalCtrl.dismiss();

  public static async Open(core: CoreProvider) {
    await (await core.modalCtrl.create({
      component: UpdatemodalPage,
      backdropDismiss: false
    })).present();
  }

}
